import type { DefaultOptionType } from 'antd/es/select';

export const filterOption = (input: string, option?: DefaultOptionType) =>
  typeof option?.label === 'string'
    ? option?.label?.toLowerCase().includes(input.toLowerCase())
    : false;
